import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-card-vaga',
  templateUrl: './card-vaga.component.html',
  styleUrls: ['./card-vaga.component.css']
})
export class CardVagaComponent implements OnInit {
  @Input() titulo;
  @Input() urlImagem;
  @Input() descricao;
  @Input() localVaga;
  @Input() urlLanding;
  @Input() urlVaga;
  @Input() empresa;

  siteUrl: string = "";

  constructor() { 
    this.siteUrl = environment.serverUrl;
  }

  ngOnInit(): void {
  }

  preventWrongWrapping (text : string) {
    return text.replace(/-/g, '‑')
  }

}
